<div class="badge-component {{className}}">
  {{ label }}
</div>
